import React, { useState } from "react";
import * as products from "../../../../../../shared/service/products";

class ProductOrderInfo extends React.Component {
  state = {};

  componentDidMount() {
    if (this.state.order === undefined) {
      // products.getOrderInfo(this.props.oid).then((res) => {
      //   this.setState({ order: res.shift() });
      // });
    }
  }

  render() {
    return this.state.order !== undefined &&
      this.state.order.payment !== undefined ? (
      <React.Fragment>
        <small className="capitalizeText">
          <strong>Payment:</strong> {this.state.order.payment}
        </small>
      </React.Fragment>
    ) : (
      ""
    );
  }
}

export default ProductOrderInfo;
